import React from 'react';
import { compose, pure } from 'recompose';
import { Home as HomePage } from '../../pages';
import { AppNav, Footer } from '../../partials';
import './home.css';

const Home = () => (
  <section className='home'>
    <header>
      <AppNav />
    </header>
    <main>
      <HomePage />
    </main>
    <Footer />
  </section>
);

export default compose(
  pure
)(Home);



// WEBPACK FOOTER //
// ./src/components/layouts/home/home.js